import { sessionSelectors, useSessionStore } from '../store/sessionStore';

const STYLE_OPTIONS = [
  { id: 'inventive', label: 'Inventive' },
  { id: 'evocative', label: 'Evocative' },
  { id: 'phrase', label: 'Phrase' },
  { id: 'compound', label: 'Compound' },
  { id: 'alternate', label: 'Alt Spelling' },
  { id: 'global', label: 'Global' },
  { id: 'dictionary', label: 'Dictionary' }
];

export const StylePicker = () => {
  const selectedStyles = useSessionStore(sessionSelectors.selectedStyles);
  const toggleStyle = useSessionStore((state) => state.toggleStyle);
  const clearStyles = useSessionStore((state) => state.clearStyles);

  return (
    <div className="style-picker-section">
      <div className="style-picker-header">
        <span className="style-picker-label">Style</span>
        {selectedStyles.length > 0 && (
          <button
            type="button"
            className="style-clear-button"
            onClick={clearStyles}
            title="Clear all styles"
          >
            Clear
          </button>
        )}
      </div>
      <div className="style-picker">
        {STYLE_OPTIONS.map((style) => (
          <button
            key={style.id}
            type="button"
            className={`tld-chip ${selectedStyles.includes(style.id) ? 'active' : ''}`}
            onClick={() => toggleStyle(style.id)}
            aria-pressed={selectedStyles.includes(style.id)}
          >
            {style.label}
          </button>
        ))}
      </div>
    </div>
  );
};
